import * as yup from 'yup';
import { endpoint, EndpointError } from '../endpoint';
import { ValidationShape, ERROR as VALIDATION_ERROR } from '../validation';
import { Hotel } from 'models/index';
import { isValidUrl } from 'utils/is-url-valid';

export type UpdateParams = { id?: string; isApiRatingHidden?: string } & Omit<
  Hotel.Model,
  'id' | 'isApiRatingHidden' | 'apiUpdatedAt'
>;
export type UpdateResult = Partial<Hotel.Model>;
export type UpdateError = EndpointError | { error: string };

const numFormatReg = /[0-9]*\.[0-9]/;

export const updateParamsSchema = yup.object().shape({
  id: yup.string(),
  createdAt: yup.string(),
  address: yup.string().required(VALIDATION_ERROR.REQUIRED),
  url: yup.string().test('is-url-valid', 'URL is not valid', (value) => {
    if (!value) return true;
    return !!value && isValidUrl(value);
  }),
  adminApiName: yup.string(),
  adminApiAddress: yup.string(),
  adminApiRating: yup.string().test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
    if (!!value) {
      const numberValue = parseFloat(value);

      if (numberValue === 10) return true;

      if (numberValue > 10 || numberValue < 0) {
        return false;
      } else if (value.length > 3) {
        return false;
      }
    }
    return true;
  }),
  breakfastRating: yup.string().test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
    if (!!value) {
      const numberValue = parseFloat(value);

      if (numberValue === 10) return true;

      if (numberValue > 10 || numberValue < 0) {
        return false;
      } else if (value.length > 3) {
        return false;
      }
    }
    return true;
  }),
  cleanlinessRating: yup
    .string()
    .test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
      if (!!value) {
        const numberValue = parseFloat(value);

        if (numberValue === 10) return true;

        if (numberValue > 10 || numberValue < 0) {
          return false;
        } else if (value.length > 3) {
          return false;
        }
      }
      return true;
    }),
  facilitiesRating: yup
    .string()
    .test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
      if (!!value) {
        const numberValue = parseFloat(value);

        if (numberValue === 10) return true;

        if (numberValue > 10 || numberValue < 0) {
          return false;
        } else if (value.length > 3) {
          return false;
        }
      }
      return true;
    }),
  goodReview: yup.string().max(36, 'Max chars amount is 36').required(VALIDATION_ERROR.REQUIRED),
  badReview: yup.string().max(36, 'Max chars amount is 36').required(VALIDATION_ERROR.REQUIRED),
  isApiRatingHidden: yup.boolean(),
  locationRating: yup.string().test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
    if (!!value) {
      const numberValue = parseFloat(value);

      if (numberValue === 10) return true;

      if (numberValue > 10 || numberValue < 0) {
        return false;
      } else if (value.length > 3) {
        return false;
      }
    }
    return true;
  }),
  makoRating: yup
    .string()
    .test('rating format test', 'Rating format is invalid. Should be 0.0 or 10', (value) => {
      if (!!value) {
        const numberValue = parseFloat(value);

        if (numberValue === 10) return true;

        if (numberValue > 10 || numberValue < 0) {
          return false;
        } else if (value.length > 3) {
          return false;
        }
      }
      return true;
    })
    .required(VALIDATION_ERROR.REQUIRED),
  name: yup.string(),
  site: yup.string().test('is-url-valid', 'URL is not valid', (value) => {
    if (!value) return true;
    return !!value && isValidUrl(value);
  }),
} as ValidationShape<UpdateParams>);

export const update = endpoint<UpdateParams, UpdateResult, UpdateError>({
  method: 'POST',
  url: () => `/hotels/update`,
});
